import { Container, Section } from '@components';

const Projects = () => {
  return (
    <div className="bg-neutral-soft-gray min-h-screen">
      <Section>
        <Container>
          <div className="text-center py-16">
            <h1 className="text-h2 text-primary-navy mb-4">Projects</h1>
            <p className="text-body text-neutral-medium-gray">
              Coming in Phase 4 - Projects Dashboard
            </p>
          </div>
        </Container>
      </Section>
    </div>
  );
};

export default Projects;
